module.exports = __webpack_public_path__ + "/hashedassets-launcher/v3/tfl_community_event_banner.0de0921f40cf883f47ca5c8ba73db169.png";